// removed by extract-text-webpack-plugin
module.exports = {"dragLayer":"DragLayer__dragLayer___2F3XX","key":"DragLayer__key___1lQMe","prize":"DragLayer__prize___xuGZR","pirate":"DragLayer__pirate___q-3Y-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DragLayer/DragLayer.css
// module id = 954
// module chunks = 0